import React from 'react';
import { useDialogs } from 'src/hooks/useDialogs';
import { Modal } from 'src/design/molecules/Modal';
import { AddPayCodeForm } from './AddPayCodeForm';

/** @registry Modal for creating/editing/deleting a pay code. */
export const AddPayCodeDialog = React.memo(() => {
  const { addPayCodeOpen, setAddPayCodeOpen, selectedPayCode } = useDialogs();

  return (
    <Modal
      opened={addPayCodeOpen}
      onClose={() => setAddPayCodeOpen(false)}
      size="lg"
      title={
        selectedPayCode
          ? `Edit Pay Code: ${selectedPayCode.name}`
          : 'Add Pay Code'
      }
    >
      <AddPayCodeForm
        selectedPayCode={selectedPayCode}
        setAddPayCodeOpen={setAddPayCodeOpen}
      />
    </Modal>
  );
});
